// src/pages/Login.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signin } from "../../slice/userSlice";
import Swal from "sweetalert2";

const Login = () => {
  const [formData, setFormData] = useState({ identifier: "", password: "" });
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLogin, message, loading } = useSelector((state) => state.user);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const tempErrors = {};
    if (!formData.identifier.trim()) tempErrors.identifier = "Email or Mobile is required.";
    if (!formData.password.trim()) tempErrors.password = "Password is required.";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    dispatch(signin(formData));
  };

  useEffect(() => {
    if (isLogin) {
      Swal.fire({
        title: "Login Successful",
        text: "Redirecting to your profile...",
        icon: "success",
        confirmButtonText: "Continue",
        confirmButtonColor: "#2B3DA8",
      }).then(() => {
        navigate("/user");
      });
    } else if (message && message !== "Logout Successfully") {
      Swal.fire({
        title: "Login Failed",
        text: message,
        icon: "error",
        confirmButtonColor: "#2B3DA8",
      });
    }
  }, [isLogin, message, navigate]);

  const inputClass = (field) =>
    `w-full px-4 py-2 rounded-lg border focus:outline-none focus:ring-2 focus:ring-indigo-600 ${
      errors[field] ? "border-red-500 focus:ring-red-400" : "border-gray-300"
    }`;

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4 py-12">
      <div className="w-full max-w-xl bg-white p-10 rounded-3xl shadow">
        <h2 className="text-3xl font-bold text-center text-[#2B3DA8] mb-8">
          Login to Your Account
        </h2>

        <form className="space-y-5" onSubmit={handleSubmit} noValidate>
          <div>
            <label className="block text-lg font-medium text-[#2B3DA8]">
              Email or Mobile
            </label>
            <input
              name="identifier"
              type="text"
              placeholder="Enter email or mobile"
              value={formData.identifier}
              onChange={handleChange}
              className={inputClass("identifier")}
            />
            {errors.identifier && (
              <p className="text-red-600 text-sm mt-1">{errors.identifier}</p>
            )}
          </div>

          <div>
            <label className="block text-lg font-medium text-[#2B3DA8]">
              Password
            </label>
            <input
              name="password"
              type="password"
              placeholder="Enter password"
              value={formData.password}
              onChange={handleChange}
              className={inputClass("password")}
            />
            {errors.password && (
              <p className="text-red-600 text-sm mt-1">{errors.password}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 mt-4 bg-[#2B3DA8] hover:bg-black hover:text-white text-white font-semibold rounded-lg transition duration-200"
          >
            {loading ? "Logging in..." : "Log In"}
          </button>
        </form>

        <p className="mt-6 text-lg text-center text-gray-600">
          Don’t have an account?{" "}
          <Link to="/register" className="text-[#2B3DA8] font-semibold hover:underline">
            Sign Up
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;